<div *ngIf="!currentView" class="h-full flex flex-col">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="!currentView">
    <mat-tab label="Pricing">
      <!-- Pricing -->
      <div class="p-4 flex flex-col gap-3">
        <!-- <sbnb-property-base-price
          *ngIf="property.counts?.airbnb > 0"
          [currency]="property.currency"
          [dynamicPricingEnabled]="
            property.dynamic_pricing?.outbound_dynamic_pricing_enabled
          "></sbnb-property-base-price> -->
        <sbnb-step-trigger
          headline="Dynamic Pricing"
          subline="Included in your plan"
          (click)="setViewDynamicPricing()"
          [new]="!$dynamicPricingOn()"
          [on]="$dynamicPricingOn()"
          [emphasize]="!$dynamicPricingOn()"></sbnb-step-trigger>

        <!-- <sbnb-step-trigger headline="Listing markups" (click)="setView(viewEnum.LISTING_MARKUPS)"></sbnb-step-trigger>
        <sbnb-step-trigger
          headline="Primary rate plan"
          (click)="setView(viewEnum.PRIMARY_RATE_PLAN)"></sbnb-step-trigger>
        <sbnb-step-trigger headline="Security deposit" (click)="setView(viewEnum.SECURITY_DEPOSIT)"></sbnb-step-trigger>
        <sbnb-step-trigger headline="Occupancy based" (click)="setView(viewEnum.OCCUPANCY_BASED)"></sbnb-step-trigger>
        <sbnb-step-trigger headline="Fees" (click)="setView(viewEnum.FEES)"></sbnb-step-trigger>
        <sbnb-step-trigger headline="Discounts" (click)="setView(viewEnum.DISCOUNTS)"></sbnb-step-trigger> -->
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div id="dynamic-pricing" class="pt-6 h-full" *ngIf="currentView === viewEnum.DYNAMIC_PRICING">
  <sbnb-sidebar-property-dynamic-pricing
    (hide)="currentView = undefined"
    [property]="property"></sbnb-sidebar-property-dynamic-pricing>
</div>

<div class="h-full" *ngIf="currentView !== null && currentView !== viewEnum.DYNAMIC_PRICING">
  <div class="h-full flex flex-col">
    <div class="flex-1 flex flex-col gap-6 p-4">
      <div class="flex items-center gap-1 mb-3 cursor-pointer" (click)="goBack()">
        <sbnb-icon icon="small-arrow-left" [size]="14"></sbnb-icon>
        <div class="text-sm m-0">Property pricing</div>
      </div>

      <sbnb-property-listing-markups
        *ngIf="currentView === viewEnum.LISTING_MARKUPS"
        [property]="property"></sbnb-property-listing-markups>
      <sbnb-property-booking-rate-plans
        *ngIf="currentView === viewEnum.PRIMARY_RATE_PLAN"
        [propertyId]="property.id"
        [propertyCurrency]="property.currency"
        [propertyName]="property.name"></sbnb-property-booking-rate-plans>
      <sbnb-property-fees-taxes-discounts
        *ngIf="
          currentView === viewEnum.SECURITY_DEPOSIT ||
          currentView === viewEnum.OCCUPANCY_BASED ||
          currentView === viewEnum.FEES ||
          currentView === viewEnum.DISCOUNTS
        "
        [property]="property"
        [section]="currentView"></sbnb-property-fees-taxes-discounts>
    </div>
  </div>
</div>
